<!--~
~ Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<form name='changePasswordForm'
  (ngSubmit)='submitForm()'
  [formGroup]='passwordForm'>
  <input type='hidden'
    id='username'
    name='username'
    autocomplete='username'
    [value]='username'/>
  <div fxLayout='column' fxLayoutAlign='start start'>
    <mat-form-field>
      <input matInput type="password"
        id='password'
        name='password'
        [placeholder]="'Current Password:'"
        autocomplete='current-password'
        formControlName="password"/>
    </mat-form-field>
    <mat-form-field>
      <input matInput type="password"
        id='new-password'
        name='new-password'
        [placeholder]="'New Password:'"
        autocomplete='new-password'
        formControlName="newPassword"/>
      <mat-error>
        {{getError('newPassword')}}
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput type="password"
        id='new-password-confirm'
        name='new-password-confirm'
        [errorStateMatcher]='matcher'
        [placeholder]="'Confirm New Password:'"
        autocomplete='new-password'
        formControlName="newPasswordConfirm"/>
      <mat-error>
        {{getError('newPasswordConfirm')}}
      </mat-error>
    </mat-form-field>
    @if (complexity) {
      <dash-gis-password-complexity [complexity]='complexity'></dash-gis-password-complexity>
    }
  </div>

  <div class='change-password-buttons' fxLayout="row" fxLayoutAlign="end center">
    <button mat-button
      type="button"
    (click)='cancelForm()'>Cancel</button>
    <button mat-button
      color='primary'
      type="submit"
    [disabled]="passwordForm.invalid">{{ submitText }}</button>
  </div>

</form>
